import { useState } from "react";

// Settings component renders a settings page with buttons to change password, email or delete account.
// When a button is clicked, it renders a form for the corresponding action.
// The form will be rendered below the buttons.
// The change password form asks for the old password, new password and confirm password.
// The change email form asks for the old email, new email and confirm email.
// The delete account button renders a delete account form that asks for the password.
const Settings = () => {
  const [activeForm, setActiveForm] = useState("");

  //   It updates the activeForm state variable to the corresponding form name.
  const handleFormChange = (formName) => {
    setActiveForm(formName);
  };

  return (
    <div className="setting-section">
      <div className="setting-content">
        <button
          className="create-button"
          onClick={() => handleFormChange("change-password")}
        >
          Change Password
        </button>
        <button
          className="create-button"
          onClick={() => handleFormChange("change-email")}
        >
          Change Email
        </button>
        <button className="create-button">Delete Account</button>

        {/* change password */}

        {activeForm === "change-password" && (
          <div className="change-password">
            <label htmlFor="password">
              Old Password <span className="required">*</span>
            </label>
            <input type="password" placeholder="Enter the old password" />
            <label htmlFor="password">
              New Password <span className="required">*</span>
            </label>
            <input type="password" placeholder="Enter the new password" />
            <label htmlFor="password">
              Confirm Password <span className="required">*</span>
            </label>
            <input type="password" placeholder="Enter the confirm password" />
            <button className="create-button">Save</button>
          </div>
        )}

        {/* change email */}

        {activeForm === "change-email" && (
          <div className="change-email">
            <label htmlFor="email">
              Old Email <span className="required">*</span>
            </label>
            <input type="email" placeholder="Enter the old email" />
            <label htmlFor="email">
              New Email <span className="required">*</span>
            </label>
            <input type="email" placeholder="Enter the new email" />
            <label htmlFor="email">
              Confirm Email <span className="required">*</span>
            </label>
            <input type="email" placeholder="Enter the confirm email" />
            <button className="create-button">Save</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Settings;
